import { render, staticRenderFns } from "./GsActivityLog.vue?vue&type=template&id=5be330ae&scoped=true&"
import script from "./GsActivityLog.vue?vue&type=script&lang=js&"
export * from "./GsActivityLog.vue?vue&type=script&lang=js&"
import style0 from "./GsActivityLog.vue?vue&type=style&index=0&id=5be330ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be330ae",
  null
  
)

export default component.exports